import { useFondByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function FondInfo({fondId}:{fondId:number}){
    const { data, error, isLoading } = useFondByIdQuery(fondId.toString());
    const {translate}=useTrads();

    return (

        error ? (
            <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
            <span>{data.name} ({data.solde}€)</span>
        ):null
    );
}
export default FondInfo;